import React, {Component} from 'react'
import {Route, Switch} from 'react-router-dom'
import Redirect from './Redirect'
import FakeLogin from './FakeLogin'

export default class App extends Component {
    render() {
        return <Switch>
            <Route path='/redirect/:to?' component={Redirect}/>
            <Route path='/fake-login' component={FakeLogin}/>
        </Switch>
    }
}
